module.exports = __webpack_public_path__ + "img/hongbao.c2895991.png";